export default "__VITE_ASSET__lFXkKIdD__"